import { apiClient } from '../utils/api';

export interface ApiQuestion {
  questionId: string;
  question: string;
  userName: string;
  questionTimestamp: string;
  isAnswered: boolean;
  answer: string;
  answerTimestamp: string;
  vendorName: string;
}

export interface QuestionsApiResponse {
  success: boolean;
  data: ApiQuestion[];
  count: number;
  message:string
}

export interface AnswerQuestionPayload {
  vendorId: string;
  questionId: string;
  answer: string;
}

// Get all questions for a vendor (optionally filtered by questionId)
export const getQuestions = async (vendorId: string, questionId?: string): Promise<QuestionsApiResponse> => {
  const url = questionId 
    ? `/vendors/${vendorId}/questions?questionId=${encodeURIComponent(questionId)}`
    : `/vendors/${vendorId}/questions`;
  const response = await apiClient.get<QuestionsApiResponse>(url);
  return response.data;
};

// Answer a question
export const answerQuestion = async (payload: AnswerQuestionPayload): Promise<any> => {
  const response = await apiClient.post(
    `/vendors/${payload.vendorId}/questions/${payload.questionId}/answer`,
    { answer: payload.answer }
  );
  return response.data;
};

// Update an answer
export const updateAnswer = async (payload: AnswerQuestionPayload): Promise<any> => {
  const response = await apiClient.put(
    `/vendors/${payload.vendorId}/questions/${payload.questionId}/answer`,
    { answer: payload.answer }
  );
  return response.data;
};






